import { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import {
  defaultTokenBridge,
  type TokenBridge,
} from '../utils/tokenBridge';

export interface TokenBridgeProps {
  /**
   * Optional custom bridge instance. Defaults to the shared global bridge.
   */
  bridge?: TokenBridge;
}

/**
 * Synchronises the current Keycloak access token into an imperative TokenBridge.
 * Place this component inside your application tree (after KeycloakProvider).
 */
export const TokenBridgeSync: React.FC<TokenBridgeProps> = ({
  bridge = defaultTokenBridge,
}) => {
  const auth = useAuth();

  useEffect(() => {
    const token = auth.user?.access_token ?? null;
    bridge.setToken(token);
  }, [auth.user, bridge]);

  // Also ensure loading/error changes clear token when auth is disabled
  useEffect(() => {
    if (!auth.isAuthenticated) {
      bridge.setToken(null);
    }
  }, [auth.isAuthenticated, bridge]);

  return null;
};
